import * as React from 'react'
import { Link } from 'react-router-dom'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import {yelpLink, wharfEventLink, caterLink, directionsLink} from '../Shared/Links'
import MailChimp from '../Shared/Mailchimp'
import Social from '../Shared/Social'
import xmasMenu from '../../ChristmasDinner.pdf'
import decMenu from '../../DecemberWine.pdf'
// import PDF__Link from '../../PDF__FILE.pdf'

export default function SwipeableTemporaryDrawer() {
  const [state, setState] = React.useState({
    right: false,
  })

  const toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setState({ ...state, [side]: open })
  }

  const navList = side => (
    <div
      className="SideNavList"
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <div className="closeIcon"><CloseIcon /></div>
      <div className="drawerWrap">
        <ul className="fullSec mobMenu">
          <li><Link to="/">Home</Link></li>
          <li className="momList menuList">
            <span className="listHd">Quick Links</span>
            <ul>
              <li><a href={yelpLink} target="_blank" rel="noreferrer">Reservations</a></li>
              <li><a href="/#togoOptions">Delivery</a></li>
              <li><a href={directionsLink} target="_blank" rel="noreferrer">Get Directions</a></li>
              <li><Link to="/happy-hour">Happy Hour</Link></li>
              <li className="sig"><Link to="/events">Holiday Events & Specials</Link></li>
            </ul>
          </li>
          <li className="momList menuList">
            <span className="listHd">Menus</span>
            <ul>
              <li><Link to="/daily-menu">Lunch</Link></li>
              <li><Link to="/dinner-menu">Dinner</Link></li>
              <li><Link to="/brunch-menu">Brunch</Link></li>
              <li><Link to="/#family-meals">Family Meals</Link></li>
              <li><Link to="/drink-menu">Drink Menu</Link></li>
            </ul>
          </li>
          <li className="momList menuList">
            <span className="listHd">Events</span>
            <ul>
              <li><Link to="/events">All Events</Link></li>
              <li><Link to="/thanksgiving">Thanksgiving</Link></li>
              <li><Link to="/pairing">November Pairing</Link></li>
              <li><a href={decMenu} target="_blank" rel="noreferrer">December Pairing</a></li>
              <li><a href={xmasMenu} target="_blank" rel="noreferrer">Christmas Dinner</a></li>
            </ul>
          </li>
          <li className="momList menuList">
            <span className="listHd">Company</span>
            <ul>
              <li><a href={caterLink} target="_blank" rel="noreferrer">Catering</a></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href={wharfEventLink} target="_blank" rel="noreferrer">Events At The Wharf</a></li>
            </ul>
          </li>
        </ul>
        <div className="fullSec mobExtra">
          <MailChimp />
          <div className="social">
            <Social showTrip="true" />
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="NavDrawer">
      <button onClick={toggleDrawer('right', true)} className="menuBtn">
        <MenuIcon /> <span className="btnText">Main Menu</span>
      </button>

      <SwipeableDrawer
        anchor='right'
        open={state['right']}
        onClose={toggleDrawer('right', false)}
        onOpen={toggleDrawer('right', true)}
        className="cNavDrawer"
      >
        {navList('right')}
      </SwipeableDrawer>
    </div>
  )
}